import { useState, useContext, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { AdminContext } from "../../context/adminContext"
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify"
import { goToBackPageTransformer } from "../../utils";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";



 


const PharamcyAddPage = () => {
 
    const {addPharmacy} = useContext(AdminContext)
    const navigate = useNavigate()
    const location = useLocation();
    const [pharamcy, setPharmacy] = useState('')
    const [num, setNum] = useState('')
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
 
    const goBack = () => {
        // console.log(window.history);
        // console.log(location.pathname)
        if (window.history.length > 3) {
          navigate(-1); // Переход на предыдущую страницу в истории
        } else {
          // console.log(location)
          navigate(goToBackPageTransformer(1, location.pathname)) 
        }
      };

    const pharamcyHandler = (el) => {
        setPharmacy(el.target.value)
        
    }

    const closeError = () => {
        setError(null)
    }

    const closeSuccess = () => {
        setSuccess(null)
    }


    const numHandler = (el) => {
        setNum(el.target.value)
        
    }

    const submitHandler = (e) => {
        e.preventDefault();
        setError(null)
        setSuccess(null)
        if(pharamcy && num)
        {
            addPharmacy(pharamcy, num).then(res => {
               
                if(res) {
                    if(res.data.error)
                    {
                        setError(res.data.error)
                        setTimeout(() => {
                            setError(null)
                        }, 12000)
                        
                    } else 
                    {
                        setSuccess('Данные сохранены') 
                        setTimeout(() => {
                            setSuccess(null)
                        }, 12000)
                        setPharmacy('')
                        setNum('')
                    }
                  
                }
                else {
                    
                    setError(res.data.error)
                    setTimeout(() => {
                        setError(null)
                    }, 12000)
                }
            })
            
        }
        
        
    }


    useEffect(() => {   document.title = 'Добавить аптеку'}, [])

    return (
      <>
          <div style={{position: 'relative', overflow: 'hidden'}}>
            <div className="container" >
        <div className="admin__user">
            
            <ButtonBack/>
        </div>
        <h1 className="login__text">
            Создать аптеку
        </h1>
    
        <div className="login__wrapper">
           
        
            <form method="post"  className="login__form" onSubmit={submitHandler}>
                <div className="login__item">
                    <label htmlFor="phName">Полное наименое аптеки:</label>
                    <input type="text" id="phName"  name="phName" value={pharamcy} className="login__input" placeholder="Аптека" autoComplete="off" required onChange={pharamcyHandler}/>
                </div>
                <div className="login__item">
                    <label htmlFor="phNum">Номер аптеки:</label>
                    <input type="number" id="phNum"  name="phNum"  value={num} className="login__input" placeholder="Номер" autoComplete="off" required maxLength="3" onChange={numHandler}/>
                </div>

                <button  className="login__wrapper__link" style={{fontSize: 29}}>Сохранить</button>
            </form>
            
        </div>
        
    </div>

      
    
        </div>
        {error && <LittleNotify title={error} close={closeError} error={true}/>}
        {success && <LittleNotify title={success} close={closeSuccess} />}
        </>
        
    )
}

export default PharamcyAddPage
